import PopoverWithDeepComment from 'InpageEditorUI/components/responsiveToolbar/PopOverWithDeepComment';
import { jsx as _jsx } from "react/jsx-runtime";
const CommentPopOverWrapper = ({
  isCommentable = false,
  id,
  children,
  shouldSaveOnComment
}) => {
  if (isCommentable) {
    return /*#__PURE__*/_jsx(PopoverWithDeepComment, {
      id: id
      //metaDescriptions/en.lyaml in collaboration-sidebar repo
      ,
      description: {
        translationKey: 'commentableArea'
      },
      shouldSaveOnComment: shouldSaveOnComment,
      children: children
    });
  }
  return children;
};
export default CommentPopOverWrapper;